export const SERVICE_ID = 'spontay-2022'
export const USER_ID = 'WEBMugxM1wkiDhh7H'